export default {
      id: "circle-grey-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svgsprite.svg#circle-grey",
      toString: function () {
        return this.url;
      }
    }